// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1024px) {
  .modal-action-pop-ballon {
    margin-top: -9% !important;
  }
}
@media only screen and (min-width: 1400px) {
  .modal-action-pop-ballon {
    margin-top: -5% !important;
  }
}
@media only screen and (min-width: 1950px) {
  .modal-action-pop-ballon {
    margin-top: -4% !important;
  }
}
.modal-action-pop-ballon {
  margin-top: -7%;
  width: 680px !important;
  height: 564px !important;
  z-index: 1000;
}
.modal-action-pop-ballon .ant-modal-content {
  background-color: transparent;
  background-image: url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/background-min.png');
  background-size: cover;
  padding: 0;
  height: 100%;
  min-height: 540px !important;
}
.modal-action-pop-ballon .ant-modal-content .ant-modal-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 540px !important;
}
.modal-action-pop-ballon .ant-modal-content .ant-modal-close {
  color: #fff;
  inset-inline-end: 4% !important;
  height: 7vh;
  width: auto;
  z-index: 5000;
}
.modal-action-pop-ballon .ant-modal-content .rectangle-popBallon-top {
  height: 29%;
  border-radius: 16px 16px 0 0;
  animation-name: rectangle-top;
  animation-duration: 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
.modal-action-pop-ballon .ant-modal-content .rectangle-popBallon-top .txt-rectangle-top {
  padding-top: 5%;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font: normal bold 20px Poppins;
  color: #FFFFFF;
}
.modal-action-pop-ballon .ant-modal-content .rectangle-popBallon-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  border-radius: 0 0 16px 16px;
  animation-name: rectangle-bottom;
  animation-duration: 2s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
.modal-action-pop-ballon .ant-modal-content .txt-rectangle-footer {
  letter-spacing: 0.11px;
  font: normal normal 500 14px Poppins;
  color: #FFFFFF;
  text-align: center;
  padding-bottom: 6%;
}
.modal-action-pop-ballon .container-spa {
  text-align: center;
  align-items: center;
  justify-content: center;
  font: normal normal 200 10px Poppins;
  color: #FFFFFF;
  margin-top: 1%;
}
.modal-action-pop-ballon .ballon-counter {
  color: #fff;
  font-weight: 800;
}
.modal-action-pop-ballon .limited-pop {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font: normal normal normal 12px Poppins;
  color: #FFFFFF;
  transform: rotate(270deg);
  position: fixed;
  right: -35%;
  top: 50%;
  margin-top: -50px;
  transform-origin: center center;
}
.modal-action-pop-ballon .ant-modal-mask {
  width: 100vw;
  height: 100vh;
  background-color: #000 no-repeat padding-box !important;
  opacity: 0.98px;
  backdrop-filter: blur(40px);
}
.modal-action-pop-ballon .ant-modal-footer {
  position: absolute;
}
.pop-animation-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fade-in 0.5s ease forwards;
  animation-duration: 2s;
  animation-iteration-count: 1;
}
.container-click-btn {
  position: absolute;
  top: 56%;
  left: 49%;
  transform: translateX(-50%);
  z-index: 2000;
  animation: click-btn 0.5s ease forwards, hide-btn 0.5s ease forwards 3s;
}
.container-click-btn .img-click-btn {
  align-items: center;
  justify-content: center;
  display: flex;
  max-width: 110px;
  max-height: 80px;
}
@keyframes click-btn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes hide-btn {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fade-in {
  from {
    height: 10%;
    opacity: 0;
  }
  to {
    height: 100%;
    opacity: 1;
  }
}
@keyframes rectangle-top {
  from {
    box-shadow: rgba(0, 0, 0, 0.2) 0px 50px 36px -28px inset;
    opacity: 0;
  }
  to {
    box-shadow: #000000 10px 50px 36px -28px inset;
    opacity: 1;
  }
}
@keyframes rectangle-bottom {
  from {
    box-shadow: rgba(0, 0, 0, 0.2) 0px -50px 36px -28px inset;
    opacity: 0;
  }
  to {
    box-shadow: #000000 10px -50px 36px -28px inset;
    opacity: 1;
  }
}
@keyframes button-pop {
  from {
    background-image: url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/cta-min.png');
    opacity: 0;
    left: 30%;
  }
  to {
    background-image: url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/cta-min.png');
    opacity: 1;
    left: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PopBallon/ShowcasePopBallon/ballonModal.less"],"names":[],"mappings":"AAAA;EAEI;IACI,0BAAA;EAAN;AACF;AAGA;EAEI;IACI,0BAAA;EAFN;AACF;AAKA;EAEI;IACI,0BAAA;EAJN;AACF;AAOA;EACI,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;AALJ;AACA;EAOQ,6BAAA;EACA,8IAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;AALR;AAPA;EAgBY,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,4BAAA;AANZ;AAdA;EAyBY,WAAA;EACA,+BAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;AARZ;AArBA;EAkCY,WAAA;EACA,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AAVZ;AA7BA;EA0CgB,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;AAVhB;AAtCA;EAsDY,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gCAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;AAbZ;AAjDA;EAkEY,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAdZ;AAxDA;EA4EQ,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,cAAA;AAjBR;AAhEA;EAqFQ,WAAA;EACA,gBAAA;AAlBR;AApEA;EA0FQ,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,+BAAA;AAnBR;AAlFA;EAyGQ,YAAA;EACA,aAAA;EACA,uDAAA;EACA,eAAA;EACA,2BAAA;AApBR;AAzFA;EAiHQ,kBAAA;AArBR;AA0BA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,qCAAA;EACA,sBAAA;EACA,4BAAA;AA1BJ;AA6BA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uEAAA;AA3BJ;AAqBA;EASQ,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AA3BR;AAgCA;EACI;IACI,UAAA;EA9BN;EAiCE;IACI,UAAA;EA/BN;AACF;AAkCA;EACI;IACI,UAAA;EAhCN;EAmCE;IACI,UAAA;EAjCN;AACF;AAoCA;EACI;IACI,WAAA;IACA,UAAA;EAlCN;EAqCE;IACI,YAAA;IACA,UAAA;EAnCN;AACF;AAsCA;EACI;IACI,wDAAA;IACA,UAAA;EApCN;EAuCE;IACI,8CAAA;IAEA,UAAA;EAtCN;AACF;AA0CA;EACI;IACI,yDAAA;IACA,UAAA;EAxCN;EA2CE;IACI,+CAAA;IACA,UAAA;EAzCN;AACF;AA6CA;EACI;IACI,uIAAA;IACA,UAAA;IACA,SAAA;EA3CN;EA8CE;IACI,uIAAA;IACA,UAAA;IACA,SAAA;EA5CN;AACF","sourcesContent":["@media only screen and (max-width: 1024px) {\n\n    .modal-action-pop-ballon {\n        margin-top: -9% !important;\n    }\n}\n\n@media only screen and (min-width: 1400px) {\n\n    .modal-action-pop-ballon {\n        margin-top: -5% !important;\n    }\n}\n\n@media only screen and (min-width: 1950px) {\n\n    .modal-action-pop-ballon {\n        margin-top: -4% !important;\n    }\n}\n\n.modal-action-pop-ballon {\n    margin-top: -7%;\n    width: 680px !important;\n    height: 564px !important;\n    z-index: 1000;\n\n    .ant-modal-content {\n        background-color: transparent;\n        background-image: url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/background-min.png');\n        background-size: cover;\n        padding: 0;\n        height: 100%;\n        min-height: 540px !important;\n\n\n        .ant-modal-body {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            height: 100%;\n            min-height: 540px !important;\n        }\n\n\n        .ant-modal-close {\n            color: #fff;\n            inset-inline-end: 4% !important;\n            height: 7vh;\n            width: auto;\n            z-index: 5000;\n        }\n\n\n        .rectangle-popBallon-top {\n            height: 29%;\n            border-radius: 16px 16px 0 0;\n            animation-name: rectangle-top;\n            animation-duration: 3s;\n            animation-iteration-count: 1;\n            animation-fill-mode: forwards;\n\n            .txt-rectangle-top {\n                padding-top: 5%;\n                text-align: center;\n                align-items: center;\n                display: flex;\n                justify-content: center;\n                font: normal bold 20px Poppins;\n                color: #FFFFFF;\n            }\n\n        }\n\n        .rectangle-popBallon-footer {\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-end;\n            align-items: center;\n            border-radius: 0 0 16px 16px;\n            animation-name: rectangle-bottom;\n            animation-duration: 2s;\n            animation-iteration-count: 1;\n            animation-fill-mode: forwards;\n        }\n\n        .txt-rectangle-footer {\n            letter-spacing: 0.11px;\n            font: normal normal 500 14px Poppins;\n            color: #FFFFFF;\n            text-align: center;\n            padding-bottom: 6%;\n        }\n\n    }\n\n    .container-spa {\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        font: normal normal 200 10px Poppins;\n        color: #FFFFFF;\n        margin-top: 1%;\n    }\n\n    .ballon-counter {\n        color: #fff;\n        font-weight: 800;\n    }\n\n    .limited-pop {\n        display: flex;\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        font: normal normal normal 12px Poppins;\n        color: #FFFFFF;\n        transform: rotate(270deg);\n        position: fixed;\n        right: -35%;\n        top: 50%;\n        margin-top: -50px;\n        transform-origin: center center;\n    }\n\n    .ant-modal-mask {\n        width: 100vw;\n        height: 100vh;\n        background-color: #000 no-repeat padding-box !important;\n        opacity: 0.98px;\n        backdrop-filter: blur(40px);\n    }\n\n    .ant-modal-footer {\n        position: absolute;\n    }\n\n}\n\n.pop-animation-container {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    z-index: 2000;\n    cursor: pointer;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    animation: fade-in 0.5s ease forwards;\n    animation-duration: 2s;\n    animation-iteration-count: 1;\n}\n\n.container-click-btn {\n    position: absolute;\n    top: 56%;\n    left: 49%;\n    transform: translateX(-50%);\n    z-index: 2000;\n    animation: click-btn 0.5s ease forwards, hide-btn 0.5s ease forwards 3s;\n\n    .img-click-btn {\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        max-width: 110px;\n        max-height: 80px;\n    }\n\n}\n\n@keyframes click-btn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes hide-btn {\n    from {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n\n@keyframes fade-in {\n    from {\n        height: 10%;\n        opacity: 0;\n    }\n\n    to {\n        height: 100%;\n        opacity: 1;\n    }\n}\n\n@keyframes rectangle-top {\n    from {\n        box-shadow: rgba(0, 0, 0, 0.20) 0px 50px 36px -28px inset;\n        opacity: 0;\n    }\n\n    to {\n        box-shadow: rgba(0, 0, 0, 1) 10px 50px 36px -28px inset;\n\n        opacity: 1;\n    }\n}\n\n\n@keyframes rectangle-bottom {\n    from {\n        box-shadow: rgba(0, 0, 0, 0.20) 0px -50px 36px -28px inset;\n        opacity: 0;\n    }\n\n    to {\n        box-shadow: rgba(0, 0, 0, 1) 10px -50px 36px -28px inset;\n        opacity: 1;\n    }\n}\n\n\n@keyframes button-pop {\n    from {\n        background-image: url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/cta-min.png');\n        opacity: 0;\n        left: 30%;\n    }\n\n    to {\n        background-image: url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/cta-min.png');\n        opacity: 1;\n        left: 50%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
